const initializeCartHeader = () => {
  const headerEl = document.querySelector(".cart-header");
  adjustTop(headerEl);

  const menuButton = document.querySelector(".cart-header .fs-menu-button a");
  menuButton.addEventListener("click", () => {
    const menuDrawer = document.querySelector("#fs-menu-drawer");
    menuDrawer.dispatchEvent(new CustomEvent("show"));
  });
};

const adjustTop = (headerEl) => {
  const el = document.querySelector(".fs-announcement-bar .fs-container");
  if (el) {
    const mainContainer = document.querySelector(".fs-main-container");
    mainContainer.classList.add("has-announcement");
    if (el.classList.contains("oneline")) {
      mainContainer.classList.add("oneline");
    }
  }
};

const cartHeaderMain = () => {
  if (!location.pathname.startsWith("/cart")) {
    return;
  }
  initializeCartHeader();
};

addEventListener("DOMContentLoaded", (event) => {
  cartHeaderMain();
});
